import Button from '@components/buttons/Button';
import AddIcon from '@mui/icons-material/Add';
import { GroupOperationInfo } from '@api/groupUpdateApi/types';

type Props = {
    operation: GroupOperationInfo;
    description?: string;
    setActiveOperation: (operation: GroupOperationInfo) => void;
    disabled?: boolean;
};

const GroupSelectionOperationCard = ({
    operation,
    description,
    setActiveOperation,
    disabled = false,
}: Props) => {
    const { operationId, printedName = '' } = operation;

    return (
        <section key={operationId} className="group-selection-operation-card">
            <div className="group-selection-operation-head">
                <div className="group-selection-operation-icon">{printedName?.[0]}</div>
                <div className="group-selection-operation-meta">
                    <div className="group-selection-operation-title-line">
                        <p className="group-selection-operation-title">{printedName}</p>
                        <span className="group-selection-operation-badge">Additive</span>
                    </div>
                    <p className="group-selection-operation-description">
                        {description ?? `Apply "${printedName}" to selected items.`}
                    </p>
                </div>
            </div>
            <Button
                text={printedName}
                img={<AddIcon fontSize="small" />}
                colorType="transparent"
                size="small"
                onClick={() => setActiveOperation(operation)}
                disabled={disabled}
            />
        </section>
    );
};

export default GroupSelectionOperationCard;
